import * as React from 'react';
import useReduxState from 'src/hooks/useReduxState';

const ContactPopup = (props) => {
    const { SetStatus, data: { isFromManualCart }} = props;
    const [, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')

    return (
        <>
                <div className="avnet-modal share-modal">
                    <div className="avnet-modal-inner">
                        {/* Modal Header */}
                        <button type="button" className="close py-3"
                                onClick={() => {
                                    SetStatus(false)
                                    if(isFromManualCart){
                                        setProductSelected({})
                                        setSearchTerm('')
                                        setTimeout(() => {
                                            document.body.style.overflow = '';
                                        }, 400)
                                    }
                                }}
                        >×
                        </button>
                        <div className="modal-header justify-content-center mt-0">
                            <h3 className="pcn-modal-heading pl-5 text-darkgreen">General Support</h3>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="clearfix"/>
                            <div className="mt-3 mb-5 text-center">
                                <a href="mailto:OnlineSupportUS@Avnet.com">OnlineSupportUS@Avnet.com</a>
                                <p className="mb-0 mt-3"><i className="fa fa-phone"/> 1-800-405-8353</p>
                            </div>
                        </div>
                        {/* Modal footer */}
                        <div className="modal-footer text-center">
                            <div className="modal-footer-actions">
                                <button type="button" className="bs5 btn btn-secondary btn-sm"
                                        onClick={() => {
                                            SetStatus(false)
                                            if(isFromManualCart){
                                                setProductSelected({})
                                                setSearchTerm('')
                                                setTimeout(() => {
                                                    document.body.style.overflow = '';
                                                }, 400)
                                            }
                                        }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    );
}

export default ContactPopup;